import { createRoot } from 'react-dom/client'
import { App } from './components/app/App'

const container = document.getElementById('app')!
const root = createRoot(container)
root.render(<App />)
